import React from 'react'
import { Link } from 'react-router-dom';
const Settings = () => {
  return (
    <div>
      
    {/* <!-- PRELOADER --> */}
    {/* <div id="preloader">
        <div className="plod">
            <span className="lod1"><img src="images/loder/1.png" alt="" loading="lazy"/></span>
            <span className="lod2"><img src="images/loder/2.png" alt="" loading="lazy"/></span>
            <span className="lod3"><img src="images/loder/3.png" alt="" loading="lazy"/></span>
        </div>
    </div>
    <div className="pop-bg"></div> */}
    {/* <!-- END PRELOADER --> */}

    {/* <!-- SEARCH --> */}
    <div className="pop-search">
        <span className="ser-clo">+</span>
        <div className="inn">
            <form>
                <input type="text" placeholder="Search here..."/>
            </form>
            <div className="rel-sear">
                <h4>Top searches:</h4>
                <a href="all-profiles.html">Browse all profiles</a>
                <a href="all-profiles.html">Mens profile</a>
                <a href="all-profiles.html">Female profile</a>
                <a href="all-profiles.html">New profiles</a>
            </div>
        </div>
    </div>
    {/* <!-- END PRELOADER --> */}

    {/* <!-- HEADER & MENU --> */}
    <div className="head-top">
        <div className="container">
            <div className="row">
                <div className="lhs">
                    <ul>
                        <li><a href="#!" className="ser-open"><i className="fa fa-search" aria-hidden="true"></i></a></li>
                        <li><a href="about.html">About</a></li>
                        <li><a href="faq.html">FAQ</a></li>
                        <li><a href="contact.html">Contact</a></li>
                    </ul>
                </div>
                <div className="rhs">
                    <ul>
                        <li><a href="tel:+9704462944"><i className="fa fa-phone" aria-hidden="true"></i>&nbsp;+01 5312
                                5312</a></li>
                        <li><a href="mailto:info@example.com"><i className="fa fa-envelope-o"
                                    aria-hidden="true"></i>&nbsp; help@company.com</a></li>
                        <li><a href="#!"><i className="fa fa-facebook" aria-hidden="true"></i></a></li>
                        <li><a href="#!"><i className="fa fa-twitter" aria-hidden="true"></i></a></li>
                        <li><a href="#!"><i className="fa fa-whatsapp" aria-hidden="true"></i></a></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    {/* <!-- END HEADER & MENU --> */}

    {/* <!-- HEADER & MENU --> */}
    <div className="menu-pop menu-pop1">
        <span className="menu-pop-clo"><i className="fa fa-times" aria-hidden="true"></i></span>
        <div className="inn">
            <img src="images/logo-b.png" alt="" loading="lazy" className="logo-brand-only"/>
            <p><strong>Best Wedding Matrimony</strong> lacinia viverra lectus. Fusce imperdiet ullamcorper metus eu
                fringilla.Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
            <ul className="menu-pop-info">
                <li><a href="#!"><i className="fa fa-phone" aria-hidden="true"></i>+92 (8800) 68 - 8960</a></li>
                <li><a href="#!"><i className="fa fa-whatsapp" aria-hidden="true"></i>+92 (8800) 68 - 8960</a></li>
                <li><a href="#!"><i className="fa fa-envelope-o" aria-hidden="true"></i>help@company.com</a></li>
                <li><a href="#!"><i className="fa fa-map-marker" aria-hidden="true"></i>3812 Lena Lane City Jackson Mississippi</a></li>
            </ul>
            <div className="menu-pop-help">
                <h4>Support Team</h4>
                <div className="user-pro">
                    <img src="images/profiles/1.jpg" alt="" loading="lazy"/>
                </div>
                <div className="user-bio">
                    <h5>Ashley emyy</h5>
                    <span>Senior personal advisor</span>
                    <a href="enquiry.html" className="btn btn-primary btn-sm">Ask your doubts</a>
                </div>
            </div>
            <div className="menu-pop-soci">
                <ul>
                    <li><a href="#!"><i className="fa fa-facebook" aria-hidden="true"></i></a></li>
                    <li><a href="#!"><i className="fa fa-twitter" aria-hidden="true"></i></a></li>
                    <li><a href="#!"><i className="fa fa-whatsapp" aria-hidden="true"></i></a></li>
                    <li><a href="#!"><i className="fa fa-linkedin" aria-hidden="true"></i></a></li>
                    <li><a href="#!"><i className="fa fa-youtube-play" aria-hidden="true"></i></a></li>
                    <li><a href="#!"><i className="fa fa-instagram" aria-hidden="true"></i></a></li>
                </ul>
            </div>
        </div>
    </div>
    {/* <!-- END HEADER & MENU --> */}

    {/* <!-- HEADER & MENU --> */}
    <div className="menu-pop menu-pop2">
        <span className="menu-pop-clo"><i className="fa fa-times" aria-hidden="true"></i></span>
        <div className="inn">
            <div className="menu-pop-help">
                <h4>Support Team</h4>
                <div className="user-pro">
                    <img src="images/profiles/1.jpg" alt="" loading="lazy"/>
                </div>
                <div className="user-bio">
                    <h5>Ashley emyy</h5>
                    <span>Senior personal advisor</span>
                    <a href="enquiry.html" className="btn btn-primary btn-sm">Ask your doubts</a>
                </div>
            </div>
            <div className="menu-pop-soci">
                <ul>
                    <li><a href="#!"><i className="fa fa-facebook" aria-hidden="true"></i></a></li>
                    <li><a href="#!"><i className="fa fa-twitter" aria-hidden="true"></i></a></li>
                    <li><a href="#!"><i className="fa fa-whatsapp" aria-hidden="true"></i></a></li>
                    <li><a href="#!"><i className="fa fa-linkedin" aria-hidden="true"></i></a></li>
                    <li><a href="#!"><i className="fa fa-youtube-play" aria-hidden="true"></i></a></li>
                    <li><a href="#!"><i className="fa fa-instagram" aria-hidden="true"></i></a></li>
                </ul>
            </div>

            <div className="late-news">
                <h4>Latest news</h4>
                <ul>
                    <li>
                        <div className="rel-pro-img">
                            <img src="images/couples/1.jpg" alt="" loading="lazy"/>
                        </div>
                        <div className="rel-pro-con">
                            <h5>Long established fact that a reader distracted</h5>
                            <span className="ic-date">12 Dec 2023</span>
                        </div>
                        <a href="blog-detail.html" className="fclick"></a>
                    </li>
                    <li>
                        <div className="rel-pro-img">
                            <img src="images/couples/3.jpg" alt="" loading="lazy"/>
                        </div>
                        <div className="rel-pro-con">
                            <h5>Long established fact that a reader distracted</h5>
                            <span className="ic-date">12 Dec 2023</span>
                        </div>
                        <a href="blog-detail.html" className="fclick"></a>
                    </li>
                    <li>
                        <div className="rel-pro-img">
                            <img src="images/couples/4.jpg" alt="" loading="lazy"/>
                        </div>
                        <div className="rel-pro-con">
                            <h5>Long established fact that a reader distracted</h5>
                            <span className="ic-date">12 Dec 2023</span>
                        </div>
                        <a href="blog-detail.html" className="fclick"></a>
                    </li>
                </ul>
            </div>

            {/* <!-- HELP BOX --> */}
            <div className="prof-rhs-help">
                <div className="inn">
                    <h3>Tell us your Needs</h3>
                    <p>Tell us what kind of service you are looking for.</p>
                    <a href="enquiry.html">Register for free</a>
                </div>
            </div>
            {/* <!-- END HELP BOX --> */}
        </div>
    </div>
    {/* <!-- END HEADER & MENU --> */}

    {/* <!-- HEADER & MENU --> */}
    <div className="hom-top">
        <div className="container">
            <div className="row">
                <div className="hom-nav">
                    {/* <!-- LOGO --> */}
                    <div className="logo">
                        <span className="menu desk-menu">
                            <i></i><i></i><i></i>
                        </span>
                        <a href="index.html" className="logo-brand"><img src="images/logo-b.png" alt="" loading="lazy"
                                className="ic-logo"/></a>
                    </div>

                    {/* <!-- TOP MENU --> */}
                    <div className="bl">
                        <ul>
                            <li className="smenu-pare">
                                <span className="smenu">Explore</span>
                                <div className="smenu-open smenu-box">
                                    <div className="container">
                                        <div className="row">
                                            <h4 className="tit">Explore category</h4>
                                            <ul>
                                                <li>
                                                    <div className="menu-box menu-box-2">
                                                        <h5>Browse profiles <span>1200+ Verified profiles</span></h5>
                                                        <span className="explor-cta">More details</span>
                                                        <a href="all-profiles.html" className="fclick"></a>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className="menu-box menu-box-1">
                                                        <h5>Wedding page <span>Make reservation</span></h5>
                                                        <span className="explor-cta">More details</span>
                                                        <a href="wedding.html" className="fclick"></a>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className="menu-box menu-box-3">
                                                        <h5>All Services<span>Lorem ipsum dummy</span></h5>
                                                        <span className="explor-cta">More details</span>
                                                        <a href="services.html" className="fclick"></a>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className="menu-box menu-box-4">
                                                        <h5>Join Now <span>Lorem ipsum dummy</span></h5>
                                                        <span className="explor-cta">More details</span>
                                                        <a href="plans.html" className="fclick"></a>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </li>
                            <li className="smenu-pare">
                                <span className="smenu">All pages</span>
                                <div className="smenu-open smenu-multi">
                                    <div className="container">
                                        <div className="row">
                                            <div className="multi-col">
                                                <div className="inn">
                                                    <h4>Page sets 1</h4>
                                                    <ul>
                                                        <li><a href="all-profiles.html">All profiles</a></li>
                                                        <li><a href="profile-details.html">Profile details</a></li>
                                                        <li><a href="wedding.html">Wedding</a></li>
                                                        <li><a href="wedding-video.html">Wedding video</a></li>
                                                        <li><a href="services.html">Our Services</a></li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <div className="multi-col">
                                                <div className="inn">
                                                    <h4>Page sets 2</h4>
                                                    <ul>
                                                        <li><a href="plans.html">Pricing plans</a></li>
                                                        <li><a href="login.html">Login</a></li>
                                                        <li><a href="sign-up.html">Sign-up</a></li>
                                                        <li><a href="photo-gallery.html">Photo gallery</a></li>
                                                        <li><a href="photo-gallery-1.html">Photo gallery 1</a></li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <div className="multi-col">
                                                <div className="inn">
                                                    <h4>Page sets 3</h4>
                                                    <ul>
                                                        <li><a href="contact.html">Contact</a></li>
                                                        <li><a href="about.html">About</a></li>
                                                        <li><a href="blog.html">Blog</a></li>
                                                        <li><a href="blog-detail.html">Blog detail</a></li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <div className="multi-col">
                                                <div className="inn">
                                                    <h4>Page sets 4</h4>
                                                    <ul>
                                                        <li><a href="enquiry.html">Ask your doubts</a></li>
                                                        <li><a href="make-reservation.html">Make Reservation</a></li>
                                                        <li><a href="faq.html">FAQ</a></li>
                                                        <li><a href="coming-soon.html" target="_blank">Coming soon</a>
                                                        </li>
                                                        <li><a href="404.html">404</a></li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <div className="multi-col full">
                                                <div className="inn">
                                                    <h4>User dashboard pages</h4>
                                        <ul>
                                            <li><a href="user-dashboard.html">Dashboard</a></li>
                                            <li><a href="user-profile.html">My profile</a></li>
                                            <li><a href="user-interests.html">Interests</a></li>
                                            <li><a href="user-chat.html">Chat lists</a></li>
                                            <li><a href="user-plan.html">My plan details</a></li>
                                            <li><a href="user-setting.html">Profile settings</a></li>
                                            <li><a href="user-profile-edit.html">Edit full profile</a></li>
                                            <li><a href="login.html">Sign in</a></li>
                                        </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </li>
                            <li className="smenu-pare">
                                <span className="smenu">Top pages</span>
                                <div className="smenu-open smenu-single">
                                    <ul>
                                        <li><a href="all-profiles.html">All profiles</a></li>
                                        <li><a href="profile-details.html">Profile details</a></li>
                                        <li><a href="wedding.html">Wedding</a></li>
                                        <li><a href="blog.html">Blog</a></li>
                                        <li><a href="blog-detail.html">Blog detail</a></li>
                                        <li><a href="about.html">About</a></li>
                                        <li><a href="contact.html">Contact</a></li>
                                        <li><a href="photo-gallery.html">Photo gallery</a></li>
                                        <li><a href="photo-gallery-1.html">Photo gallery 1</a></li>
                                        <li><a href="login.html">Login</a></li>
                                        <li><a href="sign-up.html">Sign-up</a></li>
                                        <li><a href="plans.html">Pricing plans</a></li>
                                    </ul>
                                </div>
                            </li>
                            <li><a href="plans.html">Plans</a></li>
                            <li><a href="sign-up.html">Register</a></li>
                            <li className="smenu-pare">
                                <span className="smenu">Dashboard</span>
                                <div className="smenu-open smenu-single">
                                    <ul>
                                        <li><a href="user-dashboard.html">Dashboard</a></li>
                                        <li><a href="user-profile.html">My profile</a></li>
                                        <li><a href="user-interests.html">Interests</a></li>
                                        <li><a href="user-chat.html">Chat lists</a></li>
                                        <li><a href="user-plan.html">My plan details</a></li>
                                        <li><a href="user-setting.html">Profile settings</a></li>
                                        <li><a href="user-profile-edit.html">Edit full profile</a></li>
                                        <li><a href="login.html">Sign in</a></li>
                                    </ul>
                                </div>
                            </li>
                        </ul>
                    </div>

                    {/* <!-- USER PROFILE --> */}
                    <div className="al">
                        <div className="head-pro">
                            <img src="images/profiles/1.jpg" alt="" loading="lazy"/>
                            <b>Advisor</b><br/>
                            <h4>Ashley emyy</h4>
                            <span className="fclick"></span>
                        </div>
                    </div>

                    {/* <!--MOBILE MENU--> */}
                    <div className="mob-menu">
                        <div className="mob-me-ic">
                            <span className="ser-open mobile-ser">
                                <img src="images/icon/search.svg" alt=""/>
                            </span>
                            <span className="mobile-exprt" data-mob="dashbord">
                                <img src="images/icon/users.svg" alt=""/>
                            </span>
                            <span className="mobile-menu" data-mob="mobile">
                                <img src="images/icon/menu.svg" alt=""/>
                            </span>
                        </div>
                    </div>
                    {/* <!--END MOBILE MENU--> */}
                </div>
            </div>
        </div>
    </div>
    {/* <!-- END HEADER & MENU --> */}

    {/* <!-- MOBILE MENU PO/PUP --> */}
    <div className="mob-me-all mobile_menu">
        <div className="mob-me-clo"><img src="images/icon/close.svg" alt=""/></div>
        <div className="mv-bus">
            <h4><i className="fa fa-globe" aria-hidden="true"></i> EXPLORE CATEGORY</h4>
            <ul>
                <li><a href="all-profiles.html">Browse profiles</a></li>
                <li><a href="wedding.html">Wedding page</a></li>
                <li><a href="services.html">All Services</a></li>
                <li><a href="plans.html">Join Now</a></li>
            </ul>
            <h4><i className="fa fa-align-center" aria-hidden="true"></i> All Pages</h4>
            <ul>
                <li><a href="all-profiles.html">All profiles</a></li>
                <li><a href="profile-details.html">Profile details</a></li>
                <li><a href="wedding.html">Wedding</a></li>
                <li><a href="wedding-video.html">Wedding video</a></li>
                <li><a href="services.html">Our Services</a></li>
                <li><a href="plans.html">Pricing plans</a></li>
                <li><a href="login.html">Login</a></li>
                <li><a href="sign-up.html">Sign-up</a></li>
                <li><a href="photo-gallery.html">Photo gallery</a></li>
                <li><a href="photo-gallery-1.html">Photo gallery 1</a></li>
                <li><a href="contact.html">Contact</a></li>
                <li><a href="about.html">About</a></li>
                <li><a href="blog.html">Blog</a></li>
                <li><a href="blog-detail.html">Blog detail</a></li>
                <li><a href="enquiry.html">Ask your doubts</a></li>
                <li><a href="make-reservation.html">Make Reservation</a></li>
                <li><a href="faq.html">FAQ</a></li>
                <li><a href="coming-soon.html" target="_blank">Coming soon</a></li>
                <li><a href="404.html">404</a></li>
            </ul>
            <div className="menu-pop-help">
                <h4>Support Team</h4>
                <div className="user-pro">
                    <img src="images/profiles/1.jpg" alt="" loading="lazy"/>
                </div>
                <div className="user-bio">
                    <h5>Ashley emyy</h5>
                    <span>Senior personal advisor</span>
                    <a href="enquiry.html" className="btn btn-primary btn-sm">Ask your doubts</a>
                </div>
            </div>
            <div className="menu-pop-soci">
                <ul>
                    <li><a href="#!"><i className="fa fa-facebook" aria-hidden="true"></i></a></li>
                    <li><a href="#!"><i className="fa fa-twitter" aria-hidden="true"></i></a></li>
                    <li><a href="#!"><i className="fa fa-whatsapp" aria-hidden="true"></i></a></li>
                    <li><a href="#!"><i className="fa fa-linkedin" aria-hidden="true"></i></a></li>
                    <li><a href="#!"><i className="fa fa-youtube-play" aria-hidden="true"></i></a></li>
                    <li><a href="#!"><i className="fa fa-instagram" aria-hidden="true"></i></a></li>
                </ul>
            </div>
            <div className="late-news">
                <h4>Latest news</h4>
                <ul>
                    <li>
                        <div className="rel-pro-img">
                            <img src="images/couples/1.jpg" alt="" loading="lazy"/>
                        </div>
                        <div className="rel-pro-con">
                            <h5>Long established fact that a reader distracted</h5>
                            <span className="ic-date">12 Dec 2023</span>
                        </div>
                        <a href="blog-detail.html" className="fclick"></a>
                    </li>
                    <li>
                        <div className="rel-pro-img">
                            <img src="images/couples/3.jpg" alt="" loading="lazy"/>
                        </div>
                        <div className="rel-pro-con">
                            <h5>Long established fact that a reader distracted</h5>
                            <span className="ic-date">12 Dec 2023</span>
                        </div>
                        <a href="blog-detail.html" className="fclick"></a>
                    </li>
                    <li>
                        <div className="rel-pro-img">
                            <img src="images/couples/4.jpg" alt="" loading="lazy"/>
                        </div>
                        <div className="rel-pro-con">
                            <h5>Long established fact that a reader distracted</h5>
                            <span className="ic-date">12 Dec 2023</span>
                        </div>
                        <a href="blog-detail.html" className="fclick"></a>
                    </li>
                </ul>
            </div>
            <div className="prof-rhs-help">
                <div className="inn">
                    <h3>Tell us your Needs</h3>
                    <p>Tell us what kind of service you are looking for.</p>
                    <a href="enquiry.html">Register for free</a>
                </div>
            </div>
        </div>
    </div>
    {/* <!-- END MOBILE MENU POPUP --> */}

    {/* <!-- MOBILE USER PROFILE MENU POPUP --> */}
    <div className="mob-me-all dashbord_menu">
        <div className="mob-me-clo"><img src="images/icon/close.svg" alt=""/></div>
        <div className="mv-bus">
            <div className="head-pro">
                <img src="images/profiles/1.jpg" alt="" loading="lazy"/>
                <b>user profile</b><br/>
                <h4>Ashley emyy</h4>
            </div>
            <ul>
                <li><a href="login.html">Login</a></li>
                <li><a href="sign-up.html">Sign-up</a></li>
                <li><a href="plans.html">Pricing plans</a></li>
                <li><a href="all-profiles.html">Browse profiles</a></li>
            </ul>
        </div>
    </div>
    {/* <!-- END USER PROFILE MENU POPUP --> */}

    {/* <!-- LOGIN -/-> */}
     <div className="db">
      <div className="container">
        <div className="row">
          <div className="col-md-4 col-lg-3">
            <div className="db-nav">
              <div className="db-nav-pro">
                <img src="images/profiles/12.jpg" className="img-fluid" alt="Profile" />
              </div>
              <div className="db-nav-list">
                <ul>
                  <li>
                    <Link to="/user-dashboard">
                      <i className="fa fa-tachometer" aria-hidden="true"></i> Dashboard
                    </Link>
                  </li>
                  <li>
                    <Link to="/user-my-matches">
                      <i className="fa fa-heart" aria-hidden="true"></i> My Matches
                    </Link>
                  </li>
                  <li>
                    <Link to="/user-profile">
                      <i className="fa fa-male" aria-hidden="true"></i> Profile
                    </Link>
                  </li>
                  <li>
                    <Link to="/user-interests">
                      <i className="fa fa-handshake-o" aria-hidden="true"></i> Interests
                    </Link>
                  </li>
                  <li>
                    <Link to="/user-chat">
                      <i className="fa fa-commenting-o" aria-hidden="true"></i> Chat List
                    </Link>
                  </li>
                  <li>
                    <Link to="/user-plan">
                      <i className="fa fa-money" aria-hidden="true"></i> Plan
                    </Link>
                  </li>
                  <li>
                    <Link to="/user-setting" className="act">
                      <i className="fa fa-cog" aria-hidden="true"></i> Setting
                    </Link>
                  </li>
                  <li>
                    <button className="logout-btn" onClick={() => console.log("Logging out...")}>
                      <i className="fa fa-sign-out" aria-hidden="true"></i> Log out
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

                    <div className="col-md-8 col-lg-9"/>
                        <div className="row"/>
                            <div className="col-md-12 db-sec-com"/>
                                <h2 className="db-tit">Profile settings</h2>
                                <div className="col7 fol-set-rhs"/>
                                    {/* <!--START--> */}
                                    <div className="ms-write-post fol-sett-sec sett-rhs-pro" style="">
                                        <div className="foll-set-tit fol-pro-abo-ico">
                                            <h4>Profile</h4>
                                        </div>
                                        <div className="fol-sett-box">
                                            <ul>
                                                <li>
                                                    <div className="sett-lef">
                                                        <div className="auth-pro-sm sett-pro-wid">
                                                            <div className="auth-pro-sm-img">
                                                                <img src="images/profiles/15.jpg" alt=""/>
                                                            </div>
                                                            <div className="auth-pro-sm-desc">
                                                                <h5>Anna Jaslin</h5>
                                                                <p>Premium user | Illunois</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="sett-rig">
                                                        <a href="#" className="set-sig-out">Sign Out</a>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className="sett-lef">
                                                        <div className="sett-rad-left">
                                                            <h5>Profile visible</h5>
                                                            <p>You can set-up who can able to view your profile.</p>
                                                        </div>
                                                    </div>
                                                    <div className="sett-rig">
                                                        <div className="sett-select-drop">
                                                            <select>
                                                              <option value="All users">All users</option>
                                                              <option value="Premium">Premium</option>
                                                              <option value="Free">Free</option>
                                                              <option value="Free">No-more visible(You can't visible, so no one can view your profile)</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className="sett-lef">
                                                        <div className="sett-rad-left">
                                                            <h5>Who can send you Interest requests?</h5>
                                                            <p>You can set-up who can able to make Interest request here.</p>
                                                        </div>
                                                    </div>
                                                    <div className="sett-rig">
                                                        <div className="sett-select-drop">
                                                            <select>
                                                                <option value="All users">All users</option>
                                                                <option value="Premium">Premium</option>
                                                                <option value="Free">Free</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    {/* <!--END-->	 */}
                                    {/* <!--START--> */}
                                    <div className="ms-write-post fol-sett-sec sett-rhs-acc" style="">
                                        <div className="foll-set-tit fol-pro-abo-ico">
                                            <h4>Account</h4><a href="#!" className="sett-edit-btn sett-acc-edit-eve"><i className="fa fa-edit" aria-hidden="true"></i> Edit</a>
                                        </div>
                                        <div className="fol-sett-box sett-acc-view sett-two-tab">
                                            <ul>
                                                <li>
                                                    <div>Full name</div>
                                                    <div>Anna Jaslin</div>
                                                </li>
                                                <li>
                                                    <div>Mobile</div>
                                                    <div>+01 4343 53553</div>
                                                </li>
                                                <li>
                                                    <div>Email id</div>
                                                    <div>loremipsum@gmail.com</div>
                                                </li>
                                                <li>
                                                    <div>Password</div>
                                                    <div>**********</div>
                                                </li>
                                                <li>
                                                    <div>Profile type</div>
                                                    <div>Platinum</div>
                                                </li>
                                            </ul>
                                        </div>
                            <div className="sett-acc-edit">
  <form className="form-com sett-pro-form">
    <ul>
      <li>
        <div className="fm-lab">Full name</div>
        <div className="fm-fie">
          <input type="text" defaultValue="vijaya kumar" />
        </div>
      </li>
      <li>
        <div className="fm-lab">Email id</div>
        <div className="fm-fie">
          <input type="text" defaultValue="vijaykumar@gmail.com" />
        </div>
      </li>
      <li>
        <div className="fm-lab">Password</div>
        <div className="fm-fie">
          <input type="password" defaultValue="dfght3d34" />
        </div>
      </li>
      <li>
        <div className="fm-lab">Confirm password</div>
        <div className="fm-fie">
          <input type="password" defaultValue="asg235sf" />
        </div>
      </li>
      <li>
        <div className="fm-lab">Profile type</div>
        <div className="fm-fie">
          <select>
            <option value="general">General</option>
            <option value="blogger">Blogger</option>
            <option value="business">Business</option>
            <option value="marketer">Marketer</option>
          </select>
        </div>
      </li>
      <li>
        <input type="submit" value="Update" className="sett-acc-edi-submit" />
        <input type="reset" value="Cancel" className="sett-acc-edi-can" />
      </li>
    </ul>
  </form>
</div>

                                    {/* <!--END-->	 */}
                                    {/* <!--START--> */}
                                 <div className="ms-write-post fol-sett-sec sett-rhs-not">
  <div className="foll-set-tit fol-pro-abo-ico">
    <h4>Notifications</h4>
  </div>

  <div className="fol-sett-box">
    <ul>
      <li>
        <div className="sett-lef">
          <div className="sett-rad-left">
            <h5>Interest request</h5>
            <p>Interest request email notifications</p>
          </div>
        </div>
        <div className="sett-rig">
          <div className="checkboxes-and-radios">
            <input type="checkbox" name="interest" id="sett-not-mail" defaultChecked />
            <label htmlFor="sett-not-mail"></label>
          </div>
        </div>
      </li>

      <li>
        <div className="sett-lef">
          <div className="sett-rad-left">
            <h5>Chat</h5>
            <p>New chat notifications</p>
          </div>
        </div>
        <div className="sett-rig">
          <div className="checkboxes-and-radios">
            <input type="checkbox" name="chat" id="sett-not-fri" defaultChecked />
            <label htmlFor="sett-not-fri"></label>
          </div>
        </div>
      </li>

      <li>
        <div className="sett-lef">
          <div className="sett-rad-left">
            <h5>Profile views</h5>
            <p>When someone views your profile, you get a notification at the end of the day</p>
          </div>
        </div>
        <div className="sett-rig">
          <div className="checkboxes-and-radios">
            <input type="checkbox" name="views" id="sett-not-fol" defaultChecked />
            <label htmlFor="sett-not-fol"></label>
          </div>
        </div>
      </li>

      <li>
        <div className="sett-lef">
          <div className="sett-rad-left">
            <h5>New profile match</h5>
            <p>You’ll receive email notifications about profile matches</p>
          </div>
        </div>
        <div className="sett-rig">
          <div className="checkboxes-and-radios">
            <input type="checkbox" name="match" id="sett-not-mes" defaultChecked />
            <label htmlFor="sett-not-mes"></label>
          </div>
        </div>
      </li>
    </ul>
  </div>
</div>

    {/* <!-- END --> */}

    {/* <!-- FOOTER --> */}
    <section className="wed-hom-footer">
        <div className="container">
            <div className="row foot-supp">
                <h2><span>Free support:</span> +92 (8800) 68 - 8960 &nbsp;&nbsp;|&nbsp;&nbsp; <span>Email:</span>
                    info@example.com</h2>
            </div>
            <div className="row wed-foot-link wed-foot-link-1">
                <div className="col-md-4">
                    <h4>Get In Touch</h4>
                    <p>Address: 3812 Lena Lane City Jackson Mississippi</p>
                    <p>Phone: <a href="tel:+917904462944">+92 (8800) 68 - 8960</a></p>
                    <p>Email: <a href="mailto:info@example.com">info@example.com</a></p>
                </div>
                <div className="col-md-4">
                    <h4>HELP &amp; SUPPORT</h4>
                    <ul>
                        <li><a href="about-us.html">About company</a>
                        </li>
                        <li><a href="#!">Contact us</a>
                        </li>
                        <li><a href="#!">Feedback</a>
                        </li>
                        <li><a href="about-us.html#faq">FAQs</a>
                        </li>
                        <li><a href="about-us.html#testimonials">Testimonials</a>
                        </li>
                    </ul>
                </div>
                <div className="col-md-4 fot-soc">
                    <h4>SOCIAL MEDIA</h4>
                    <ul>
                        <li><a href="#!"><img src="images/social/1.png" alt=""/></a></li>
                        <li><a href="#!"><img src="images/social/2.png" alt=""/></a></li>
                        <li><a href="#!"><img src="images/social/3.png" alt=""/></a></li>
                        <li><a href="#!"><img src="images/social/5.png" alt=""/></a></li>
                    </ul>
                </div>
            </div>
            <div className="row foot-count">
                <p>Company name Site - Trusted by over thousands of Boys & Girls for successfull marriage. <a
                        href="sign-up.html" className="btn btn-primary btn-sm">Join us today !</a></p>
            </div>
        </div>
    </section>
    {/* <!-- END --> */}
    {/* <!-- COPYRIGHTS --> */}
    <section>
        <div className="cr">
            <div className="container">
                <div className="row">
                    <p>Copyright © <span id="cry">2017-2020</span> <a href="#!" target="_blank">Company.com</a> All
                        rights reserved.</p>
                </div>
            </div>
        </div>
    </section>
    </div>
     </div>
  )
}
;
export default Settings
